import React from "react";
import styled from "styled-components";
import LinkIcon from "./icons/LinkIcon";

const InbioLinkContainer = styled("div")`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 16px;
    margin-top: 24px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #ffffff;
    border-radius: 8px;
    // box-shadow: 5px 3px 30px black;
    color: #111111;

    &:before {
      content: "";
      margin: -35px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      filter: blur(10px);
      z-index: -1;
    }

    &:hover {
      background-color: #111111;
      color: #fff;
      border: 1px solid #111111;
    }

    &:active {
      background-color: #111111;
      color: #fff;
      border: 1px solid #111111;
    }
  `;

  const InbioLinkTitleContainer = styled("div")`
    width: 100%;
  `;

  const InbioLinkTitle = styled("div")`
    flex: 1;
    word-break: break-word;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 130%;
    text-align: center;
    padding-left: 16px;
    padding-right: 16px;
  `;

export default function InbioLinkContent({ content, getIpAndPublishToSns }) {
  let link = content.description;
  let category = "External Link"

  if (link.includes("go.magik.ly")) {
    category = "Classic - MagicLink"
    link = new URL(link);
    link.searchParams.set('inbio', content.hash_id);
  }

  return (
    content.description && (
      <InbioLinkContainer
        onClick={() => {
          getIpAndPublishToSns({
            payload: {
              actor_type: "InbioCustomer",
              category: category,
              action: "clicked",
              label: link,
              value: content.id,
              page: window.location.href
            },
            topic: "product_usage_stats",
          });
          window.open(link, "_blank")
        }}
      >
        <LinkIcon />
        <InbioLinkTitleContainer>
          <InbioLinkTitle>{content.title}</InbioLinkTitle>
        </InbioLinkTitleContainer>
        <div style={{ width: 24, height: 24 }} />
      </InbioLinkContainer>
    )
  );
}
